/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XSmallBoldIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAxUlEQVR4nO1USw7CIBAdjPfiBMzghqJ2U+M9uIVu1KvWjFbT1hZoQOuiL2E17zP8BmDB30FKuUZtD7gxewAQERLBXNawNsgm2h5R27pZF+fcaozLNea8+KwNBihty1ZAPRbSN3+s5679GBTqbkgMJwSBZE9tA6XtrTEQiopzp0bFdYq5t0tM7Dy4E0ztPDZEZTKHoTPv3Ul+c8wR8u1LFh/PlN5n7qvB/B9NJYwKpW05/7CTPK7RVETFbtK4RlNFjesFP8cdRKgVkrZd5z8AAAAASUVORK5CYII=)
 */
export const XSmallBoldIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.94 19.06a1.5 1.5 0 1 0 2.12-2.12L14.12 12l4.94-4.94a1.5 1.5 0 1 0-2.12-2.12L12 9.88 7.06 4.94a1.5 1.5 0 1 0-2.12 2.12L9.88 12l-4.94 4.94a1.5 1.5 0 1 0 2.12 2.12L12 14.12l4.94 4.94Z"
        className={colorClass}
      />
    </svg>
  );
};
